import { createFileRoute, redirect } from "@tanstack/react-router";

// English schema alias: Service → /gestao-de-atendimento (main service hub)
export const Route = createFileRoute("/service")({
  beforeLoad: () => {
    throw redirect({ to: "/gestao-de-atendimento", replace: true });
  },
  component: () => null,
});
